"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftJs = require("draft-js");

var _constants = require("../lib/constants");

var _default = function _default(editorState, command, keyboardEvent) {
  if (command === 'tab') {
    var newEditorState = _draftJs.RichUtils.onTab(keyboardEvent, editorState, _constants.MAX_LIST_DEPTH);

    if (newEditorState !== editorState) {
      return newEditorState;
    }
  }

  return undefined;
};

exports.default = _default;
module.exports = exports.default;